import React, {useReducer} from 'react'
import {useSelector, useDispatch, connect} from 'react-redux'
import Api from "../../Services/Api";
import {logged, updateUser, updateUserSupplyFeeds,updateUserDemandFeeds, reset} from "./usersSlice";
import store from "../../store/store";
import User from "../../Models/User";
import {useNavigate} from "react-router-dom";
import {init, isLoading} from "../app/App";
import {setLoading} from "../app/appSlice";



export const check =  async () => {

     const userLogged =  await Api.check().then( (r) => {
        if (r) {
             store.dispatch(updateUser(r))
            return true
        } else {
            isLoading(false)
             store.dispatch(logged(false))
            return false
        }
    }).catch(() => {
        return false
    })

    return userLogged
}

export const updateDemandFeeds = async (data) => {
    store.dispatch(updateUserDemandFeeds(data))
}


export const updateSupplyFeeds = async (data) => {
    store.dispatch(updateUserSupplyFeeds(data))
}

export const logout =   () => {

             User.destroy();
             store.dispatch(reset())
             store.dispatch(logged(false))
}

export const login = async (loginCredentials) => {

    await isLoading(true)
    const response = await Api.login(loginCredentials).then( (response) => {

        if(response)
        {

            console.log("authenticated response", response)
            User.authenticated(response.user)
            // let {name, email} = response.user
            // let supplyFeeds = response.supplyFeeds


             return init().then(r => true);

            // store.dispatch(updateUser({name, email}))
            // store.dispatch(updateUserSupplyFeeds(supplyFeeds))

        }
        else {
             isLoading(false)
            return false
        }
    }).catch(() => {
        return false
    })

    return response
}





